import { ONBOARDING_PAGE_STATUS } from '@src/constants';
import { useAccount } from '@src/contexts';
import { Path } from '@src/navigations/routes';
import React from 'react';
import { Navigate } from 'react-router-dom';

const Home = () => {
  const { isLoggedIn, businessVariant, user, isRemittanceBusiness } = useAccount();

  /**
   * 1 = user hasn't filled his profile 2 = user has filled his profile
   */
  const userOnboardingStatus = user?.userOnboardingStatus;

  if (isLoggedIn) {
    if (userOnboardingStatus === ONBOARDING_PAGE_STATUS) {
      return <Navigate to={Path.Onboarding} replace />;
    }

    if (businessVariant === 'receiver') {
      return <Navigate to={Path.ReceiverDashboard} replace />;
    }

    if (isRemittanceBusiness) {
      return <Navigate to={Path.SenderSetupGuide} replace />;
    }

    return <Navigate to={Path.SenderDashboard} replace />;
  }

  return <Navigate to={Path.Login} replace />;
};

export default Home;
